import React from "react";

const ParticipantPickerToolbar = ({ searchValue, onSearchChange, selectionLocked }) => (
  <>
    <label style={{ fontWeight: 600, fontSize: "15px", marginBottom: "8px", display: "block" }}>
      {selectionLocked ? "Assigned Participant" : "Select Participant"}
    </label>
    {selectionLocked && (
      <div style={{ fontSize: "12px", color: "#8a7340", marginBottom: "8px", fontStyle: "italic" }}>
        The participant cannot be changed for an existing booking.
      </div>
    )}
    <input
      className="form-control mb-3"
      placeholder="Search by name or organisation"
      value={searchValue}
      onChange={(e) => onSearchChange(e.target.value)}
    />
  </>
);

export default ParticipantPickerToolbar;
